import $ from 'jquery';

import FormFieldComponent from 'chairisher/component/form/field';

/**
 * Helper function to get the value from a piece of data rather than checking datum && datum.value repeatedly.
 *
 * @deprecated Use optional chaining instead, e.g. datum?.value
 * @param {Object=} datum An object containing a value key, E.G { value: "100.00" }
 * @returns {any} The value, if available, otherwise null
 */
export function getValueForDatum(datum) {
    return datum ? datum.value : null;
}

/**
 * Helper function to see if a datum is not null or undefined.
 * This is equivalent to getValueForDatum != null, but avoids confusing comparison.
 *
 * @param {Object=} datum An object containing a value key, E.G { value: "100.00" }
 * @returns {boolean} Whether the datum's 'value' key is set and isn't null.
 */
export function doesDatumExist(datum) {
    const value = datum?.value;
    return value !== undefined && value !== null;
}

/**
 * Renders field errors
 *
 * @param {Object|Array} productData Object containing data rendered in shipping section fields
 * @param {boolean} isViewInReviewMode Whether the view is in review mode
 * @param {function} formGroupGetter
 * @param {function} disclaimerAlertsFormGroupGetter
 */
export function renderShippingErrors(
    productData,
    isViewInReviewMode,
    formGroupGetter,
    disclaimerAlertsFormGroupGetter,
) {
    const errorItemClass = 'error-item';
    const hasErrorClass = 'has-error';

    productData.forEach((product) => {
        const productId = product.id?.value;

        // shipping options should never have errors since one should always be defaulted, but just in case...
        const errors = (product.shipping_partner_code.errors || []).filter(
            (error) => isViewInReviewMode || !error.is_review,
        );

        const $formGroup = formGroupGetter(productId);
        // Note: jQuery is strict about passing in booleans into `toggleClass`
        $formGroup.toggleClass(hasErrorClass, !!errors.length);
        $formGroup.find('.js-errors').html(FormFieldComponent.marshalMessageList(errors, errorItemClass));
        //
        // disclaimers
        //
        const $disclaimerAlertsFormGroup = disclaimerAlertsFormGroupGetter(productId);
        if (product.has_blocking_disclaimer) {
            const disclaimerErrors = (product.has_blocking_disclaimer.errors || []).filter(() => isViewInReviewMode);

            $disclaimerAlertsFormGroup.addClass(hasErrorClass);
            $disclaimerAlertsFormGroup.html(FormFieldComponent.marshalMessageList(disclaimerErrors, errorItemClass));
        } else {
            $disclaimerAlertsFormGroup.removeClass(hasErrorClass);
            $disclaimerAlertsFormGroup.html('');
        }
    });
}

/**
 * @param {Object} productData
 * @return {boolean} an indication of whether trade insurance is available for the given product.
 */
export function isTradeInsuranceAvailable(productData) {
    return !!productData?.is_trade_insurance_available?.value;
}

/**
 * Renders information about trade insurance for each product if available.
 *
 * @param {Object|Array} productData Object containing data rendered in shipping section fields
 * @param {function} tradeInsuranceContainerGetter
 */
export function renderTradeInsurance(productData, tradeInsuranceContainerGetter) {
    const $template = $($('#js-template-trade-plus').html());

    productData.forEach((product) => {
        const productId = product.id.value;
        const $container = tradeInsuranceContainerGetter(productId);
        $container.html(isTradeInsuranceAvailable(product) ? $template.clone() : '');
    });
}
